module.exports = __webpack_public_path__ + "img/3F3A2F_91D0A5_7D876A_94977B-256px.dc2b37e4.png";